import { FC } from 'react';

import { PhotoOrInitials } from '../../../../shared/components/PhotoOrInitials';
import { colorTokens } from '../../../../shared/components/variables';

import { Container, StatusTag } from './SrsAvatarStatus.style';

interface SrsAvatarStatusProps {
  pictureUrl?: string;
  key?: string;
  fullName: string;
  fontSize?: number;
  statusSize?: number;
  size?: number;
  status?: string;
}

export const SrsAvatarStatus: FC<SrsAvatarStatusProps> = ({
  pictureUrl,
  key,
  fullName,
  status,
  fontSize,
  size = 92,
  statusSize = 24,
}) => {
  return (
    <Container>
      <PhotoOrInitials pictureUrl={pictureUrl} key={key} fullName={fullName} size={size} fontSize={fontSize} />
      {status && <StatusTag $color={getColorForStatus(status)} $statusSize={statusSize} />}
    </Container>
  );
};

const getColorForStatus = (status: string) => {
  switch (status) {
    case 'online':
      return colorTokens.success.main;
    case 'unavailable':
      return colorTokens.warning.main;
    case 'offline':
      return colorTokens.error.main;
    default:
      return '';
  }
};
